import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, () => this.setState({ error: null }))
      }
      return (
        <div
          className="rounded-xl p-6 flex flex-col items-center justify-center gap-3"
          style={{ background: '#1b1c1b', minHeight: 120, border: '1px solid rgba(255,180,155,0.15)' }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: '1.5rem', color: '#555a54' }}>
            error_outline
          </span>
          <p className="font-label text-center" style={{ fontSize: '11px', color: '#555a54' }}>
            Widget konnte nicht geladen werden
          </p>
          <button
            onClick={() => this.setState({ error: null })}
            style={{ background: '#252625', border: 'none', borderRadius: 8, padding: '5px 14px', cursor: 'pointer', color: '#8d928a', fontFamily: 'inherit', fontSize: '10px' }}
          >
            Erneut versuchen
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
